import React, { useState } from 'react';
import { Box, Button, Typography, TextField, Modal } from '@mui/material';
import { useDispatch } from 'react-redux';
import { ISubTopic } from '../../../../store/SubTopicSlice';
import { generateQuestion } from '../../../../store/GptQuestionGenerateSlice';

export interface IGenerateQuizModal {
  open: boolean;
  onClose: () => void;
  subTopicObj?: ISubTopic;
}

const GenerateQuizModal: React.FC<IGenerateQuizModal> = ({
  open,
  onClose,
  subTopicObj,
}) => {
  const topicObj = subTopicObj?.topic;
  // State for form fields
  const [curriculum, setCurriculum] = useState(topicObj?.curriculum || '');
  const [grade, setGrade] = useState(topicObj?.grade || '');
  const [subject, setSubject] = useState(topicObj?.subject || '');
  const [topic, setTopic] = useState(topicObj?.name || '');
  const [subTopic, setSubTopic] = useState(subTopicObj?.name || '');
  const [details, setDetails] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);

  const dispatch = useDispatch();

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleGenerate = async () => {
    const prompt = `Generate a mcq question according to below data.\n
      Curriculum: ${curriculum}
      Grade: ${grade}
      Subject: ${subject}
      Topic: ${topic}
      SubTopic: ${subTopic}
      ${details ? `Additional details: ${details}` : ''}.
    For the markingSchema, mention the correct answer number and Explain the correct answer in detailed manner. The explanation should be easy to understand, conversational, engaging, and suitable for students`;

    const formData = new FormData();
    formData.append('message', prompt);
    if (selectedFile !== null) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      formData.append('file', selectedFile);
    }

    dispatch(generateQuestion(formData));
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          maxWidth: 500,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: '20px',
        }}
      >
        <Typography
          id="modal-title"
          component="h2"
          sx={{
            fontWeight: 'bold',
            fontSize: '1.5rem',
            textAlign: 'center',
          }}
        >
          Generate Questions with AI
        </Typography>

        <TextField
          fullWidth
          label="Curriculum"
          value={curriculum}
          onChange={(e) => setCurriculum(e.target.value)}
          margin="normal"
          sx={{ mt: 4 }}
        />
        <TextField
          fullWidth
          label="Grade"
          value={grade}
          onChange={(e) => setGrade(e.target.value)}
          margin="normal"
        />
        <TextField
          fullWidth
          label="Subject"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          margin="normal"
        />
        <TextField
          fullWidth
          label="Topic"
          value={topic}
          onChange={(e) => setTopic(e.target.value)}
          margin="normal"
        />
        <TextField
          fullWidth
          label="SubTopic"
          value={subTopic}
          onChange={(e) => setSubTopic(e.target.value)}
          margin="normal"
        />
        <TextField
          fullWidth
          label="Resource"
          type="file"
          InputLabelProps={{
            shrink: true,
          }}
          onChange={handleFileChange}
          margin="normal"
        />
        <TextField
          fullWidth
          label="Additional Details"
          placeholder="Additional Details"
          value={details}
          onChange={(e) => setDetails(e.target.value)}
          margin="normal"
        />

        <Button
          variant="contained"
          color="inherit"
          onClick={onClose}
          sx={{ mt: 2 }}
        >
          Dismiss
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleGenerate}
          sx={{ mt: 2, ml: 2, float: 'inline-end' }}
        >
          Generate
        </Button>
      </Box>
    </Modal>
  );
};

export default GenerateQuizModal;
